<template>
  <div class="banner">
    <div class="kong"></div>
    <div class="container">
      <div class="left">
        <div class="zimg">
          <img src="../assets/logo2.png" alt="">
        </div>
      </div>
      <div class="right">
        <div class="sec-title">
          <h2 class="top">公司介绍</h2>
        </div>
        <div class="text " style="font-weight: regular;">
          <p>
            公司致力于发展成为一流的数字贸易服务商，推动跨境电商业务合规化、阳光化，助推数字经济发展。公司自主研发了跨境电商综合服务平台系统，平台功能包含通关模块、税务模块、外汇模块、金融服务模块，为电商企业提供报关、报税、结汇、融资一站式服务。跨境电商综合服务平台实现通关数据在电商企业和海关、税务、外管、银行之间实现安全、稳定、顺畅的交互传输，为跨境电商企业开展业务提供稳定高效的系统支持。平台可推动跨境电商业务申报和监管便利化，提升跨境电商外贸服务水平。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
      }
    },
  }
</script>
<style scoped>
  .text>p {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .client-logo img:hover {
    transform: scale(1.5);
    transition: 1s;
  }

  .img-fluid {
    max-width: 100%;
    height: auto;
  }

  .client-logo {
    float: left;
    width: 249px;
    padding: 50px;
    border-right: 1px solid #e7e7e7;
    border-bottom: 1px solid #e7e7e7;
    overflow: hidden;
    background: #fff;
    height: 120px;
  }


  .right p {
    color: #292828;
    margin: 20px 0;
  }

  .sec-title h2 {
    font-size: 25px;
    color: #F47310;
    padding-bottom: 0;
  }

  .right {
    width: 600px;
    height: 330px;
    float: right;
    margin-top: 50px;
  }

  .zimg {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .left {
    width: 500px;
    height: 330px;
    margin: 50px 0px 0px 0px;
    float: left;
  }

  .kong {
    width: 100%;
    height: 125px;
  }

  .banner {
    background-image: none;
    background-color: #f8f8f8;
  }

  .container {
    width: 1200px;
    margin: 0 auto !important;
    min-height: 600px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Business.vue